import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConversations } from '../store/slices/messagingSlice';

const GlobalMessageMonitor = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      // Initial fetch only - WebSocket events will handle updates
      dispatch(fetchConversations());
    }
  }, [dispatch, isAuthenticated]);

  return null;
};

export default GlobalMessageMonitor; 